<template>
  <div class="updatSeting">
    <el-row>
      <div class="model-header setting">
        <h2>Config Header Menu</h2>
        <el-button @click="logModel.dialogVisibleLog = true" size="small" type="info" class="btn-create">Xem log</el-button>
      </div>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="14">
        <div v-for="(category) in modelData.menu_top" :key="category.key" style="padding-top: 10px;">
          <div class="line line-1 pt-2">
            <el-col :span="7">
              <el-input placeholder="Tên" v-model="category.name" class="input-seach"></el-input>
            </el-col>
            <el-col :span="13">
              <el-input placeholder="Link" v-model="category.link" class="input-seach"></el-input>
            </el-col>
            <el-col :span="2">
              <el-input placeholder="Ưu tiên" v-model="category.priority" class="input-seach"></el-input>
            </el-col>
            <el-button @click.prevent="removeCategory(category, modelData.menu_top)" class="button" size="mini" type="danger" icon="el-icon-delete"></el-button>
          </div>
          <div style="padding-left: 40px;">
            <div v-for="(set) in category.options" :key="set.key">
              <!-- content category -->
              <div class="line line-2">
                <div>
                  <el-col :span="6">
                    <el-input placeholder="Tên" v-model="set.name" class="input-seach"></el-input>
                  </el-col>
                  <el-col :span="12">
                    <el-input placeholder="Link" v-model="set.link" class="input-seach"></el-input>
                  </el-col>
                  <el-col :span="2">
                    <el-input placeholder="Ưu tiên" v-model="set.priority" class="input-seach"></el-input>
                  </el-col>
                  <el-button class="button" type="warning" icon="el-icon-delete" size="mini" @click.prevent="removeSet(set, category.options)"></el-button>
                  <el-button class="button" type="primary" icon="el-icon-plus" size="mini" @click="addSetSon(set.options)"></el-button>
                </div>
                <!-- cap con thu 3-->
                <div class="line line-3" v-if="set.options" v-for="(child) in set.options" :key="child.key" style="margin-left: 40px;">
                  <el-col :span="7">
                    <el-input placeholder="Tên" v-model="child.name" class="input-seach"></el-input>
                  </el-col>
                  <el-col :span="12">
                    <el-input placeholder="Link" v-model="child.link" class="input-seach"></el-input>
                  </el-col>
                  <el-col :span="2">
                    <el-input placeholder="Ưu tiên" v-model="child.priority" class="input-seach"></el-input>
                  </el-col>
                  <el-button class="button" type="warning" icon="el-icon-delete" size="mini" @click.prevent="removeSet(child, set.options)"></el-button>
                </div>
              </div>
              <!-- end content category -->
            </div>
            <el-button class="huhu" type="info" size="mini" @click="addSet(category.options)">Thêm link phụ</el-button>
          </div>
        </div>
        <el-button class="huhu" type="primary" size="mini" @click="addCategory()">Thêm link chính</el-button>
      </el-col>
      <el-col :span="10">
        <h2>Danh sách Link mặc định</h2>
        <div>
          <div v-for="item in listLinkDefault" :key="item.key">
            <span style="min-width: 180px;display: inline-block"> {{ item.name }}</span>  {{ item.link }}
          </div>
        </div>
      </el-col>
    </el-row>
    <div style="padding-top: 20px">
      <el-button
        :disable="!canSubmit"
        :loading="!canSubmit"
        type="warning"
        size="small"
        @click="updateModelHomeMenu()">Cập nhật</el-button>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="'Lịch sử thay đổi'"
      :visible.sync="logModel.dialogVisibleLog"
      width="45%">
      <div class="log-class-user" v-if="logModel.logs">
        <div
          class="item"
          :key="index_1"
          v-for="(item, index_1) in logModel.logs">
          <strong>{{ item.user_request_name }} - {{ item.user_request_email }}</strong> đã cập nhật cấu hình
          <div>
            <span class="time">{{ item.time }}</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="logModel.dialogVisibleLog = false" size="small">Cancel</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import tinymce from 'vue-tinymce-editor'
import ls from 'local-storage'
export default {
  name: 'ConfigHeaderMenu',
  components: {
    tinymce
  },
  metaInfo () {
    return {
      title: 'Config Header Menu'
    }
  },
  data () {
    return {
      canSubmit: true,
      logModel: {
        dialogVisibleLog: false,
        activeName: 'first',
        logs: {}
      },
      tinymce: {
        toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link image media | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
      },
      modelData: {

      },
      modelData_ID: 0,
      image: '',
      image_path: '',
      upload: {
        uploadProcess: false,
        url: process.env.API_URI + 'configs/upload',
        url_not_resize: process.env.API_URI + 'configs/upload-not-resize',
        url_fit_fix: process.env.API_URI + 'configs/upload-fit-fix/1440/400/720/200',
        url_fit_fix2: process.env.API_URI + 'configs/upload-not-resize-2/500/300/200',
        headers: {
          Authorization: ''
        }
      },

      listLinkDefault: []
    }
  },
  computed: {
    ...mapGetters('account', ['accountInfo'])
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchModelHomeMenu()
    this.configUpload()
    this.fetchLinkDefault()
  },
  methods: {
    fetchLinkDefault () {
      axios.post('get-list-link-web-defaultt').then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.listLinkDefault = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    handleImageAdded: async function (file, success, failure) {
      // images_upload_handler: handleImageAdded // Vứt vào đoạn option cạnh chữ 500px
      let formData = new FormData()
      formData.append('file', file.blob())
      let response = await axios.post('configs/upload-not-resize', formData)
      if (response.code === 1) {
        success(response.data.path)
      } else {
        return false
      }
    },
    getImage (data) {
      return process.env.IMAGE_S3_URL + 'storage/images/configs/' + data
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'configs-home', text: 'Config Header Menu' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Cấu hình Upload
    configUpload () {
      const token = ls.get('authen', '')
      if (token) {
        this.upload.headers.Authorization = `Bearer ${token.access_token}`
      } else {
        this.upload.headers.Authorization = 'Bearer'
      }
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'home-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModelHomeMenu () {
      this.canSubmit = false
      axios.get('configs/header-menu-882').then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.modelData = response.data.value
            this.modelData_ID = response.data.id
            this.logModel.logs = response.data.logs
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    updateModelHomeMenu (formName) {
      this.canSubmit = false
      let data = {
        'value': this.modelData
      }
      axios.put('configs/' + this.modelData_ID, data).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success'
            })
            this.fetchModelHomeMenu()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    addCategory () {
      this.modelData.menu_top.push({
        'key': Math.floor(Math.random() * 100000) + 1,
        'name': '',
        'link': '',
        'priority': 0,
        'open': 0,
        'options': []
      })
    },
    addSet (option) {
      let temp = {
        'key': Math.floor(Math.random() * 100000) + 1,
        'name': '',
        'link': '',
        'priority': 0,
        'open': '',
        'options': []
      }
      option.push(temp)
    },
    addSetSon (option) {
      let temp = {
        'key': Math.floor(Math.random() * 100000) + 1,
        'name': '',
        'link': '',
        'priority': 0,
        'open': ''
      }
      option.push(temp)
    },
    removeSetSon (item, options) {
      var index = options.indexOf(item)
      if (index !== -1) {
        options.splice(index, 1)
      }
    },
    removeSet (item, options) {
      var index = options.indexOf(item)
      if (index !== -1) {
        options.splice(index, 1)
      }
    },
    removeCategory (item, options) {
      var index = options.indexOf(item)
      if (index !== -1) {
        options.splice(index, 1)
      }
    },

    // Upload Ảnh
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('Ảnh trường có dung lượng ảnh tối đa là 2M')
      }
      return isLt2M
    },
    handleAvatarSuccess (response) {
      this.upload.uploadProcess = false
      if (response.code) {
        this.image = response.data.name
        this.image_path = response.data.path_sm
      }
    },
    handleAvatarProcess (event, file, fileList) {
      this.upload.uploadProcess = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
.huhu {
  margin-top: 10px;
}
.el-button {
  margin-left: 2px;
  height: 32px;
}
.line {
  display: block;
  align-items: center;
  margin-bottom: 10px;
}
.line input {
  margin-right: 10px;
}
.image-preview {
  height: 50px;
  width: 50px;
  margin-right: 10px;
}
.line-1 {
  padding-top: 10px;
}
.line-3 {
  padding-top: 10px;
}
.line-clear {
  background-color: #048F49;
  color: #fff;
}
</style>
<style type="text/css">
.updatSeting .course-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
}
.course-uploader .el-upload:hover {
  border-color: #409EFF;
}
.updatSeting .course-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 180px;
  height: 100px;
  line-height: 100px !important;
  text-align: center;
}
.updatSeting .courseSettig {
  width: 100px;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/config-home/UpdateHeaderMenu.vue